import { withForm } from '@/components/form';
import { SectionCard } from '@/components/ui';

import type { AddressFormItem } from '../../contactSchema';
import { addressTypeEnum, defaultFormValues } from '../../contactSchema';
import { AddItemButton, RepeaterItem } from './RepeaterItem';

const titleCase = (s: string) => (s ? s[0].toUpperCase() + s.slice(1) : s);

const TYPE_OPTIONS = [
  { value: '', label: '—' },
  ...addressTypeEnum.options
    .filter((v) => v !== '')
    .map((v) => ({ value: v, label: titleCase(v) })),
];

const empty = (): AddressFormItem => ({});

export const AddressesSection = withForm({
  defaultValues: defaultFormValues,
  render: function AddressesSection({ form }) {
    return (
      <SectionCard
        title="Addresses"
        actions={<AddItemButton onClick={() => form.pushFieldValue('contact.addresses', empty())} />}
      >
        <form.AppField name="contact.addresses">
          {(field) => (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              {(field.state.value ?? []).map((_, i) => (
                <RepeaterItem key={i} onRemove={() => field.removeValue(i)} removeLabel="Remove address">
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                    <div className="ds-form-grid-2">
                      <form.AppField name={`contact.addresses[${i}].type`}>
                        {(f) => <f.Select label="Type" options={TYPE_OPTIONS} />}
                      </form.AppField>
                      <form.AppField name={`contact.addresses[${i}].street`}>
                        {(f) => <f.TextField label="Street" />}
                      </form.AppField>
                    </div>
                    <div className="ds-form-grid-2">
                      <form.AppField name={`contact.addresses[${i}].city`}>
                        {(f) => <f.TextField label="City" />}
                      </form.AppField>
                      <form.AppField name={`contact.addresses[${i}].state`}>
                        {(f) => <f.TextField label="State / Region" />}
                      </form.AppField>
                    </div>
                    <div className="ds-form-grid-2">
                      <form.AppField name={`contact.addresses[${i}].postalCode`}>
                        {(f) => <f.TextField label="Postal Code" />}
                      </form.AppField>
                      <form.AppField name={`contact.addresses[${i}].country`}>
                        {(f) => <f.TextField label="Country" />}
                      </form.AppField>
                    </div>
                    <form.AppField name={`contact.addresses[${i}].primary`}>
                      {(f) => <f.Checkbox label="Primary address" />}
                    </form.AppField>
                  </div>
                </RepeaterItem>
              ))}
            </div>
          )}
        </form.AppField>
      </SectionCard>
    );
  },
});
